<template #content>
    <Dialog 
        :visible="visible" 
        @update:visible="updateVisible"
        header="Perfil"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-3"
        modal >
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="nome" v-model="form.nome" class="w-full" />
                        <label for="nome">Nome</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['nome'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="login" v-model="form.login" class="w-full" />
                        <label for="login">Login</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['login'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="email" v-model="form.email" class="w-full" />
                        <label for="email">E-mail</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['email'] }}</div>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button 
                    type="submit" 
                    label="Salvar" 
                    severity="success"
                    icon="pi pi-save" 
                    class="flex align-items-center justify-content-center" 
                    :loading="isLoading" />
                <Button 
                    label="Fechar" 
                    severity="warn"
                    icon="pi pi-times" 
                    @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" 
                    :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';

import Auth from '@/service/auth.js';

export default {
    components: { Dialog, 
                  FloatLabel, 
                  Button,
                  InputText, 
                  Password,
                  Button
                },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
    },
    emits: ['save','close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
        }
    },
    methods: {
        onShow() {
            this.form = {...this.data};
        },
        onHide() {
            // ...
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;
            Auth.profile(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: response.data.msg, life: 3000 });
                    this.$emit('save', response.data.data);
                    this.$emit('close');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        if(err.erros) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>